import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide
} from '@material-ui/core'
import { DashboardAthenaTable } from './DashboardAthenaTable'
import OpenSearchDropdown from './OpenSearchDropdown'
import LoadingButton from './LoadingButton'
import {
  resourceWorkAssignmentAuditCols,
  resourceWorkAssignmentAuditFieldsCols
} from '../constants/ResourceCols'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function ResourceWorkAssignmentAuditLog(props) {
  const { headers } = props
  const { credentials } = props.fetchInitialData

  const [selectedWorkAssignment, setSelectedWorkAssignment] = useState('')
  const [tableKey, setTableKey] = useState(null)
  const [showTable, setShowTable] = useState(false)
  const [fieldsDialog, setFieldsDialog] = useState({
    isOpen: false,
    recordHistoryId: null
  })
  const [clearTrigger, setClearTrigger] = useState(false)

  useEffect(() => {
    setSelectedWorkAssignment('')
    setShowTable(false)
    setFieldsDialog({ isOpen: false, recordHistoryId: null })
    setClearTrigger(prev => !prev)
  }, [headers?.hrOrg, headers?.employee])

  const handleSearch = e => {
    e.preventDefault()
    if (!selectedWorkAssignment) return
    setShowTable(true)
    setTableKey(`${selectedWorkAssignment}-${Date.now()}`)
  }

  const tableDataTransformation = rows => {
    return rows.map(row => ({
      ...row,
      Effective_dt_link: (
        <div
          className='editLink'
          onClick={() => setFieldsDialog({ isOpen: true, recordHistoryId: row.RECORD_HISTORY_ID })}
        >
          {row.EFFECTIVE_DT}
        </div>
      )
    }))
  }

  return (
    <div>
      <Dialog
        open={fieldsDialog.isOpen}
        TransitionComponent={Transition}
        maxWidth='xl'
        scroll='body'
        keepMounted
        onClose={() => setFieldsDialog({ isOpen: false, recordHistoryId: null })}
      >
        <DialogTitle>Field Changes</DialogTitle>
        <DialogContent>
          {fieldsDialog.recordHistoryId && (
            <DashboardAthenaTable
              {...props}
              isTempTable={false}
              key={fieldsDialog.recordHistoryId}
              params={{ recordHistoryId: fieldsDialog.recordHistoryId }}
              tableColumns={resourceWorkAssignmentAuditFieldsCols}
              reportName='hr_resource_workassignment_audit_fields'
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            color='primary'
            onClick={() => setFieldsDialog({ isOpen: false, recordHistoryId: null })}
            className='primaryVLButton'
            variant='contained'
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <form onSubmit={handleSearch}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <OpenSearchDropdown
            id='workAssignment'
            required
            width='300px'
            label='Work Assignment'
            page='RESOURCE'
            entity='WORKASSIGNMENT'
            searchFields={['DISPLAY']}
            accessToken={credentials.user.accessToken}
            credentials={credentials}
            clearTrigger={clearTrigger}
            filters={{
              HRORGANIZATION: headers?.hrOrg,
              EMPLOYEE: headers?.employee
            }}
            onChange={val => setSelectedWorkAssignment(val?.VALUE || '')}
          />
          <div style={{ marginLeft: '0.5rem' }}>
            <LoadingButton
              label='Search'
              color='primaryVLButton'
              buttonType='submit'
              disabled={!selectedWorkAssignment}
            />
          </div>
        </div>
      </form>

      {showTable && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={tableKey}
            params={{ ...headers, workAssignment: selectedWorkAssignment }}
            tableColumns={resourceWorkAssignmentAuditCols}
            reportName='hr_resource_workassignment_audit'
            transform={tableDataTransformation}
          />
        </div>
      )}
    </div>
  )
}
